import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'warehouse-manage';

export const state = {

    isShow: true,
    isOutShow: true,

    detailParams: {},
    routerUrl: '',
    buttonType: "",
    isView: false,//查看模式
    storageClass: "",
    audit: false,
    billCode: ''

}
export const mutations = {

    setShowFlag(state, flag) {

        state.isShow = flag
    },
    setisOutShow(state, data) {
        state.isOutShow = data
    },
    setstorageClass(state, data) {
        state.storageClass = data


    },
    setWarehouseView(state, flag) {
        state.isView = flag
    },
    setAudit(state, flag) {
        state.audit = flag
    },

    setDetailParams(state, data) {
        state.detailParams = { ...data }
    },
    setWarehouseRouterUrl(state, url) {
        state.routerUrl = url
    },
    setButtonType(state, type) {
        state.buttonType = type
    },
    setBillCode(state, code) {
        state.billCode = code
    }

}
export const actions = {

}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/warehouse-manage/index.js